export default class JobseekerEmploymentsTemp {
    constructor(
        public jobseeker_employment_id?: string,
        public designation ?: string,
        public organization ?: string,
        public is_current_company ?: string,
        public salary_type  ?: string,
        public annual_salary_in_lacs  ?: number,
        public annual_salary_inthousands  ?: number,
        public current_location  ?: string,
        public current_location_details  ?: string,
        public working_from_inyears ?: string,
        public worked_till_inmonths  ?: string,
        public worked_till  ?: string,
        public worked_till_in_years  ?: string,
        public working_from_inmonths  ?: string,
        public job_profile_description  ?: string,
        public duration_of_notice_period  ?: string,
        public serving_notice_period  ?: string,
        public skills ?: string,
        public industry  ?: string,
        public functional_area  ?: string,
        public role  ?: string,
        public position_level  ?: string,
        public job_category  ?: string,
        public job_type  ?: string,
        public jobseeker_id?: number,
        public provider?: string,
        public state?: string,
        public specialization  ?: string,
        public specialization_sub_category?:string
    ){

    }
}